import { allPatterns, PatternElement } from '../models';


/**
 * Parses the journal number pattern and converts it to an array of text segments and dynamic elements.
 * @param pattern The journal number pattern string
 * @returns Array of PatternElement objects representing the parsed pattern
 */
export function parsePattern(pattern: string): PatternElement[] {
  if (!pattern) {
    return [];
  }
  const result: PatternElement[] = [];
  const regexp = /%<(category|short_year|year|start_year|short_start_year|end_year|short_end_year)>s|%<no>\d+d|[^%]+/g;
  const matches = pattern.match(regexp);
  if (matches) {
    matches.forEach(match => {
      if (match.match(/^%<(.+?)>s$/) || match.match(/^%<no>\d+d$/)) {
        const element = allPatterns.find(element => element.value === match);
        result.push({ label: element?.label || match, value: match });
      } else {
        result.push({ label: match, value: match });
      }
    });
  }
  return result;
}

/**
 * Generates a sample journal number based on the provided pattern and category.
 * @param pattern The journal number pattern string
 * @param category The category initials to use in the journal number
 * @returns A sample journal number string
 */
export function patternSample(pattern: string, category: string): string {
  if (!pattern) {
    return '';
  }

  const today = new Date();
  const year = today.getFullYear().toString();
  const startYear = (today.getFullYear() - 1).toString();
  let no = '1';
  let numberMatch = pattern.match(/%<no>(0)?(\d+)d/);
  if (numberMatch && numberMatch[1] === '0') {
    no = no.padStart(parseInt(numberMatch[2]), '0');
  }

  return pattern
    .replace('%<year>s', year).replace('%<short_year>s', year.slice(-2))
    .replace('%<start_year>s', startYear).replace('%<short_start_year>s', startYear.slice(-2))
    .replace('%<end_year>s', year).replace('%<short_end_year>s', year.slice(-2))
    .replace('%<category>s', category)
    .replace(/%<no>\d+d/, no);
}
